import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Socialcontainer extends Component {
  constructor(props) {
    super(props);
    this.getFacebookShare = this.getFacebookShare.bind(this);
    this.getTwitterShare = this.getTwitterShare.bind(this);
    this.getLinkedInShare = this.getLinkedInShare.bind(this);
    this.getEmail = this.getEmail.bind(this);
    this.state = {
      SocialContent: '',
    };
  }

  componentDidMount() {
    const headingContent =
      document.getElementById('contentHeading').textContent;
    this.setState({
      SocialContent: headingContent,
    });
  }

  getTwitterShare(title) {
    window.open(
      `https://twitter.com/share?text=${encodeURIComponent(title)}&url=${escape(window.location.href)}&hashtags=PayPal,PayPal4Business`,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
    return false;
  }

  getFacebookShare(title) {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${escape(window.location.href)}&title=${encodeURIComponent(title)}`,
      'Facebook',
      'width=640, height=400,scrollbars=yes,resizable=yes',
    );
    return false;
  }

  getLinkedInShare(title, country, slugId) {
    window.open(
      `https://www.linkedin.com/shareArticle?mini=true&title=${encodeURIComponent(title)}&url=https://www.paypal.com/${country}/brc/article/${slugId}`,
      '',
      'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=yes,resizable=yes',
    );
    return false;
  }

  getEmail(title) {
    window.location = `mailto:?body=${window.location.href}&subject=${encodeURIComponent(title)}`;
  }

  render() {
    const slugId = this.props.articleInfo.content['url-slug'];
    const title = this.state.SocialContent;
    const country = this.props.country && this.props.country.toLowerCase();

    return (
      <div className="socialsectionContainer" id={this.props.id}>
        <div className="social-icon-container social-icons-inline">
          <div className="twitter-icon iconspace">
            <button
              data-pa-click={`twitter|${slugId}`}
              onClick={this.getTwitterShare.bind(this, title)}
              className="twitter"
              aria-label={'Share on Twitter'}
            />
          </div>

          <div className="linkedin-icon iconspace">
            <button
              data-pa-click={`linkedIn|${slugId}`}
              onClick={this.getLinkedInShare.bind(this, title, country, slugId)}
              className="linkedin"
              aria-label={'Share on LinkedIn'}
            />
          </div>

          <div className="fb-icon iconspace">
            <button
              data-pa-click={`facebook|${slugId}`}
              onClick={this.getFacebookShare.bind(this, title)}
              className="facebook"
              aria-label={'Share on Facebook'}
            />
          </div>

          <div className="mail-icon iconspace">
            <button
              data-pa-click={`email|${slugId}`}
              onClick={this.getEmail.bind(this, title)}
              className="mail"
              aria-label={'Share on email'}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Socialcontainer;

Socialcontainer.propTypes = {
  articleInfo: PropTypes.shape({
    content: PropTypes.shape({
      ['url-slug']: PropTypes.string,
      heading: PropTypes.string,
    }),
  }),
};
